import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CheckoutButtonComponent } from '../checkout-button/checkout-button.component';
import { MenuOrderTreeComponent } from '../menu-order-tree/menu-order-tree.component';
import { OrderTreeComponent } from './order-tree.component';
import { ClearOrderButtonComponent } from '../clear-order-button/clear-order-button.component';
import { GrouporderInfoComponent } from '../grouporder-info/grouporder-info.component';
import { GrouporderInfoContentComponent } from '../grouporder-info-content/grouporder-info-content.component';
import { OrderTreeAdjustmentComponent } from '../order-tree-adjustment/order-tree-adjustment.component';
import { OrderTreeContentComponent } from '../order-tree-content/order-tree-content.component';
import { OrderTreeFeeComponent } from '../order-tree-fee/order-tree-fee.component';
import { OrderTreeFundraiserComponent } from '../order-tree-fundraiser/order-tree-fundraiser.component';
import { OrderTreeItemComponent } from '../order-tree-item/order-tree-item.component';
import { OrderTreePendingDiscountComponent } from '../order-tree-pending-discount/order-tree-pending-discount.component';
import { OrderTreePricingComponent } from '../order-tree-pricing/order-tree-pricing.component';
import { OrderTreeSpecialComponent } from '../order-tree-special/order-tree-special.component';
import { OrderTreeSpecialWithoutItemsComponent } from '../order-tree-special-without-items/order-tree-special-without-items.component';
import { OrderWarningComponent } from '../order-warning/order-warning.component';
import { OrderWarningsModalComponent } from '../order-warnings-modal/order-warnings-modal.component';
import { CouponInputComponent } from '../coupon-input/coupon-input.component';
import { CouponInstructionsModalComponent } from '../coupon-instructions-modal/coupon-instructions-modal.component';
import { CouponsModalComponent } from '../coupons-modal/coupons-modal.component';
import { AccountCouponButtonComponent } from '../account-coupon-button/account-coupon-button.component';
import { LoyaltyIndicatorComponent } from '../loyalty-indicator/loyalty-indicator.component';
import { GrouporderInvitationModalComponent } from '../grouporder-invitation-modal/grouporder-invitation-modal.component';
import { GrouporderInvitationComponent } from '../grouporder-invitation/grouporder-invitation.component';
import { GrouporderStateButtonsComponent } from '../grouporder-state-buttons/grouporder-state-buttons.component';
import { StartOverButtonComponent } from '../../menu/start-over-button/start-over-button.component';
import { TranslateModule } from '@ngx-translate/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { RouterModule } from '@angular/router';
import { OrderNotificationComponent } from '../order-notification/order-notification.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OrderNotificationItemInfoComponent } from '../order-notification/order-notification-item-info/order-notification-item-info.component';
import { QuantitiesComponent } from '../quantities/quantities.component';
import { HeaderOrderTreeComponent } from '../../core/header/header-order-tree/header-order-tree.component';
import { SharedModule } from '../shared.module';
import { TextMaskModule } from 'angular2-text-mask';
import { OrderBoxComponent } from '../order-box/order-box.component';
import { MobileOrderMenuComponent } from '../../core/header/mobile-order-menu/mobile-order-menu.component';
import { OrderNotificationUpsellButtonComponent } from '../order-notification/order-notification-upsell-button/order-notification-upsell-button.component';
import { OrderNotificationInfoMessageComponent } from '../order-notification/order-notification-info-message/order-notification-info-message.component';
import { OrderNotificationUpsellDoneMessageComponent } from '../order-notification/order-notification-upsell-done-message/order-notification-upsell-done-message.component';
import { CheckoutOrderTreeItemComponent } from 'app/checkout/checkout-order-tree-item/checkout-order-tree-item.component';
import {
  NgbDatepickerModule,
  NgbTimepickerModule,
  NgbPopoverModule,
  NgbDropdownModule,
  NgbTooltipModule,
} from '@ng-bootstrap/ng-bootstrap';
import { OrderTreeGroupComponent } from '../order-tree-group/order-tree-group.component';
import { OrderTreeItemIngredientInfoComponent } from '../order-tree-item-ingredient-info/order-tree-item-ingredient-info.component';
import { GroupOrderJoinModalComponent } from '../group-order-join-modal/group-order-join-modal.component';

@NgModule({
  declarations: [
    CheckoutButtonComponent,
    MenuOrderTreeComponent,
    OrderTreeComponent,
    ClearOrderButtonComponent,
    GrouporderInfoComponent,
    GrouporderInfoContentComponent,
    OrderTreeAdjustmentComponent,
    OrderTreeContentComponent,
    OrderTreeFeeComponent,
    OrderTreeFundraiserComponent,
    OrderTreeItemComponent,
    OrderTreePendingDiscountComponent,
    OrderTreePricingComponent,
    OrderTreeSpecialComponent,
    OrderTreeSpecialWithoutItemsComponent,
    OrderWarningComponent,
    OrderWarningsModalComponent,
    CouponInputComponent,
    CouponInstructionsModalComponent,
    LoyaltyIndicatorComponent,
    GrouporderInvitationModalComponent,
    GrouporderInvitationComponent,
    GrouporderStateButtonsComponent,
    StartOverButtonComponent,
    OrderNotificationComponent,
    OrderNotificationItemInfoComponent,
    QuantitiesComponent,
    HeaderOrderTreeComponent,
    OrderBoxComponent,
    MobileOrderMenuComponent,
    CouponsModalComponent,
    AccountCouponButtonComponent,
    OrderNotificationUpsellButtonComponent,
    OrderNotificationInfoMessageComponent,
    OrderNotificationUpsellDoneMessageComponent,
    CheckoutOrderTreeItemComponent,
    OrderTreeGroupComponent,
    OrderTreeItemIngredientInfoComponent,
    GroupOrderJoinModalComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    FontAwesomeModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    TextMaskModule,
    NgbDatepickerModule,
    NgbTimepickerModule,
    NgbPopoverModule,
    NgbDropdownModule,
    NgbTooltipModule,
  ],
  exports: [
    CheckoutButtonComponent,
    MenuOrderTreeComponent,
    OrderTreeComponent,
    ClearOrderButtonComponent,
    GrouporderInfoComponent,
    GrouporderInfoContentComponent,
    OrderTreeContentComponent,
    OrderTreeFeeComponent,
    OrderTreeFundraiserComponent,
    OrderTreeItemComponent,
    OrderTreePendingDiscountComponent,
    OrderTreePricingComponent,
    OrderTreeSpecialComponent,
    OrderTreeSpecialWithoutItemsComponent,
    OrderWarningComponent,
    OrderWarningsModalComponent,
    CouponInputComponent,
    CouponInstructionsModalComponent,
    LoyaltyIndicatorComponent,
    GrouporderInvitationModalComponent,
    GrouporderInvitationComponent,
    GrouporderStateButtonsComponent,
    StartOverButtonComponent,
    OrderNotificationComponent,
    OrderNotificationItemInfoComponent,
    QuantitiesComponent,
    OrderBoxComponent,
    OrderTreeGroupComponent,
    OrderTreeItemIngredientInfoComponent,
    GroupOrderJoinModalComponent,
  ],
})
export class OrderTreeModule {}
